import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";

import { useNavigate } from "react-router-dom";

import Switch from "@mui/material/Switch";

import api from "../../API/api";

import GeneralAction from "../panel/generalAction";

export default function ViewCareer(props) {
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);
  const [recruiter, setRecruiter] = useState();
  const [career, setCareer] = useState();

  useEffect(() => {
    getCareer();
  }, []);

  const getCareer = () => {
    setLoader(true);
    api
      .getCareer()
      .then((res) => {
        setCareer(res.data.careers);
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err.response);
      });
  };

  // const [status, setStatus] = useState(true);
  const changeCareerStatus = (id, status) => {
    // console.log(id, status);
    setLoader(true);
    api
      .changeCareerStatus(id, status)
      .then((res) => {
        // console.log(res);
        // getCareer();
        setCareer((prevCareer) =>
          prevCareer.filter((career) => career.career_id !== id)
        );
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err.response);
      });
  };
  const deleteCareer = () => {};

  return (
    <div className="py-3">
      <button className="btn btn-primary " onClick={()=>getCareer()}>Click to Refresh</button>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead sx={{ backgroundColor: "black" }}>
            <TableRow>
              <TableCell
                sx={{ color: "white", fontWeight: "800", padding: "15px" }}
              >
                Post
              </TableCell>
              <TableCell
                sx={{ color: "white", fontWeight: "800", padding: "15px" }}
              >
                End Date
              </TableCell>

              <TableCell
                sx={{ color: "white", fontWeight: "800", padding: "15px" }}
              >
                Status
              </TableCell>

              <TableCell
                sx={{ color: "white", fontWeight: "800", padding: "15px" }}
                align="right"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {career &&
              career.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                     {row.post}{" "}
                  </TableCell>
                  <TableCell> {row.end_date} </TableCell>

                  <TableCell>
                    {" "}
                    {row.status === 1 ? (
                      <span className="text-success">Active</span>
                    ) : (
                      <span className="text-danger">Inactive</span>
                    )}
                    <Switch
                      checked={row.status}
                      onChange={() => changeCareerStatus(row.id, row.status)}
                      name="loading"
                      color="primary"
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Button size="small">
                      <GeneralAction
                        data={row}
                        handleClickOpen={props.handleClickOpen}
                      />
                    </Button>
                    <Button
                      size="small"
                      onClick={() => {
                        changeCareerStatus(row.career_id, row.status);
                      }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
